import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import ParentNav from '../components/ParentNav';
import SupportTicketsPage from '../components/SupportTicketsPage';
import { HelpCircle, ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';

export default function ParentSupport() {
  const navigate = useNavigate();

  useEffect(() => {
    if (!localStorage.getItem('parent_token')) navigate('/parent/login');
  }, [navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 via-white to-rose-50">
      <ParentNav />

      <div className="pt-20 pb-12 px-4">
        <div className="max-w-7xl mx-auto">
          {/* Header — matches Daily Insights style */}
          <div className="flex items-center justify-between mb-6 flex-wrap gap-3">
            <div className="flex items-center gap-4">
              <Button variant="ghost" onClick={() => navigate('/parent/dashboard')}>
                <ArrowLeft className="w-4 h-4 mr-2" /> Back
              </Button>
              <div>
                <h1 className="text-2xl font-bold text-gray-900 flex items-center gap-2">
                  <HelpCircle className="w-6 h-6 text-orange-500" />
                  Support Center
                </h1>
                <p className="text-gray-600 text-sm">Raise a ticket — our team responds within 24–48 hours.</p>
              </div>
            </div>
          </div>

          <SupportTicketsPage
            tokenKey="parent_token"
            role="parent"
            portalTitle="Parent Support"
            onBack={() => navigate('/parent/dashboard')}
            headerless
          />
        </div>
      </div>
    </div>
  );
}
